import { lazy, Suspense } from 'react';

import FeatureFlagContextProvider from 'context/feature-flag.context';
import PostHogProviderWrapper from 'context/post-hog-provider-wrapper';
import posthog from 'posthog-js';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';

import CallContextProvider from './context/call-context';
import CustomerProvider from './context/customer-context';
import PermissionContextProvider from './context/permission-context';
import StoreProvider from './context/store-context';

import './assets/css/style.scss';

const Home = lazy(() => import('./components/home/home'));

ReactDOM.render(
  <Suspense
    fallback={
      <div
        style={{ display: window.sdkModeEnabled ? 'none' : 'block' }}
        className="lazy-spinner"
      />
    }
  >
    <ErrorBoundary
      fallback={null}
      onError={(error, info) => {
        posthog?.capture('commonError', { error, info });
        console.warn({ error, info });
      }}
    >
      <PostHogProviderWrapper>
        <FeatureFlagContextProvider>
          <CustomerProvider>
            <StoreProvider>
              <CallContextProvider>
                <PermissionContextProvider>
                  <Home />
                </PermissionContextProvider>
              </CallContextProvider>
            </StoreProvider>
          </CustomerProvider>
        </FeatureFlagContextProvider>
      </PostHogProviderWrapper>
    </ErrorBoundary>
  </Suspense>,
  document.getElementById('conferwith')
);
